<template>
  <div class="profile-edit">
    <router-link class="button" :disabled="saving || formstate.$dirty" :to="{ name: 'profile' }">Back to profile</router-link>
    <h3>User profile for {{user.name}}</h3>
    <p>Edit your profile</p>
    <vue-form :state="formstate" @submit.prevent>
      <div class="detailscontainer">
        <div>
          <validate tag="label">
            <span>Name *</span>
            <input v-model="model.name" required name="name" @blur="save" />

            <field-messages name="name">
              <div>&nbsp;</div>
              <div slot="required">Name is a required field</div>
            </field-messages>
          </validate>

          <validate tag="label">
            <span>Username *</span>
            <input v-model="model.username" required name="username" @blur="save" />

            <field-messages name="username">
              <div>&nbsp;</div>
              <div slot="required">Username is a required field</div>
            </field-messages>
          </validate>

          <div class="status">
            <div class="success" v-if="saved">Saved!</div>
            <div class="error">{{saveError}}</div>
          </div>
        </div>
      </div>
    </vue-form>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import pick from 'lodash/pick'
export default {
  data() {
    return {
      formstate: {},
      model: pick(this.$store.state.user, ['name', 'username']),
      saving: false,
      saved: false,
      saveError: null,
    }
  },
  computed: {
    ...mapGetters({
      user: 'user'
    }),
  },
  methods: {
    save() {
      if (this.formstate.$valid) {
        this.saveError = null
        this.saving = true
        axios.patch('/auth/me', this.model).then(response => {
          this.$store.commit('patchUser', response.data)
          this.saved = true
          this.formstate._reset()
          setTimeout(() => this.saved = false, 2000)
        }).catch(error => {
          let message = error.message
          if (error.response.status === 409) {
            message = error.response.data.message
          }
          this.saveError = "There was an error while saving: " + message
        }).then(() => {
          this.saving = false
        })
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.profile-edit
  padding 30px

.profile
  padding 0 30px

label
  font-weight 300

  span
    display block
    font-weight bold

  .hint
    font-weight normal
    font-size small
    font-style italic
    margin-bottom 10px

  &.vf-field-invalid
    > div
      font-weight bold
      color palevioletred

.status
  font-weight bold

  .success
    color mediumseagreen

  .error
    color palevioletred
</style>
